<template>
  <div :class="[sourceCode === 'aisino' ? 'aisino-heard' : 'heard']">
    <div class="nav-box" v-if="sourceCode !== 'aisino'">
      <div class="nav">
        <span>{{heardTitle}}</span>
        <div class="nav-btn">
          <span v-if="this.$store.state.userInfo.id">
            <span
              class="nav-name"
            >{{cjt === false ? this.$store.state.userInfo.nickname : '用户' + this.$store.state.userInfo.id}}</span>
            <span v-if="sourceCode !== 'aisino'" class="nav-logout" @click="logout">
              <span v-if='isHiddenLogout=="999"'>退出</span>
              </span>
          </span>
          <el-button type="primary" plain @click="login()" v-else>登录</el-button>
        </div>
      </div>
    </div>
    <div class :class="[sourceCode === 'aisino' ? 'aisino-tab-box' : 'tab-box']">
      <div class :class="[sourceCode === 'aisino' ? 'aisino-nav-content' : 'nav-content']">
        <div class :class="[sourceCode === 'aisino' ? 'aisino-nav-tab' : 'nav-tab']">
          <div
            :class="[sourceCode === 'aisino' ? (avtion === '/' ? 'aisino-atab-name' : 'aisino-tab-name') : (avtion === '/' ? 'atab-name' : 'tab-name')]"
            @click="routerLinkToPageHook('/')"
          >
            <img
              :src="dy_icon"
              class="nav-icon"
              alt
              style="width: 30px; height: 30px"
              v-if="sourceCode === 'aisino'"
            />
            <p>答疑库</p>
          </div>
          <div
            :class="[sourceCode === 'aisino' ? (avtion === '/question' ? 'aisino-atab-name' : 'aisino-tab-name') : (avtion === '/question' ? 'atab-name' : 'tab-name')]"
            @click="routerLinkToPageHook('/question')"
          >
            <img
              :src="wd_icon"
              class="nav-icon"
              alt
              style="width: 30px; height: 30px"
              v-if="sourceCode === 'aisino'"
            />
            <p>随便问</p>
          </div>
          <div v-if="sourceCode === 'aisino'" class="edition">版本号100000001</div>
          <div
            v-if="sourceCode !== 'aisino'"
            :class="avtion === '/center' ? 'atab-name' : 'tab-name'"
            @click="routerLinkToPageHook('/center')"
          >我的</div>
          <div
            v-if="cjt === true && sourceCode !== 'aisino'"
            class="cjtTs"
          >本产品答疑服务由中税答疑承接，只为便捷帮助学习者。</div>
          <!-- <div class="aisino-nav-btn" v-if="sourceCode === 'aisino'">
            <span v-if="this.$store.state.userInfo.id">
              <span
                class="nav-name"
              >{{cjt === false ? this.$store.state.userInfo.nickname : '用户' + this.$store.state.userInfo.id}}</span>
              <span v-if="sourceCode !== 'aisino'" class="nav-logout" @click="logout">退出</span>
            </span>
            <el-button type="primary" plain @click="login()" v-else>登录</el-button>
          </div> -->
        </div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <div v-if="sourceCode === 'aisino'" class="empty-div"></div>
      <!-- <div class v-if="sourceCode !== 'aisino'" :class="[sourceCode === 'aisino' ? 'aisino-tool-right' : 'tool-right']"> -->
      <div class :class="[sourceCode === 'aisino' ? 'aisino-tool-right' : 'tool-right']">
        <div v-if="sourceCode !== 'aisino'" class :class="[sourceCode === 'aisino' ? 'aisino-nav-right' : 'nav-right']">
          <div class="web-view" @click="tolink('https://gzh.shui12366.com/html/slcxl/')">
            <div class="web-icon">
              <img :src="pc_icon" />
            </div>
            <p>税率查询</p>
          </div>
          <div class="web-view" @click="tolink('https://gzh.shui12366.com/html/fpll/')">
            <div class="web-icon">
              <img :src="pc_icon_2" />
            </div>
            <p>发票</p>
          </div>
          <div class="web-view" @click="tolink('https://gzh.shui12366.com/html/yh/')">
            <div class="web-icon">
              <img :src="pc_icon_3" />
            </div>
            <p>优惠</p>
          </div>
          <div class="web-view" @click="tolink('https://gzh.shui12366.com/html/zq/')">
            <div class="web-icon">
              <img :src="pc_icon_4" />
            </div>
            <p>征期</p>
          </div>
        </div>
        <div v-if="sourceCode !== 'aisino'&&sourceCode!='chanjetDefault'&&sourceCode!='jsyh_xcsf'" class="nav-right" style="padding-top:20px;">
          <p class="remind-title">特别提醒：</p>
          <p class="remind-content">为了方便您及时收到回复提醒，您可扫描下方二维码，进入小程序添加订阅。</p>
          <img class="remind-img" :src="ewm" alt />
        </div>
        <div v-if="sourceCode === 'aisino'" class="aisino-nav-right-img" >
          <img :src="rightImg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API_DATA } from "@/api/index";
import pc_icon from "@/assets/pc_icon.png";
import pc_icon_4 from "@/assets/pc_icon_4.png";
import pc_icon_2 from "@/assets/pc_icon_2.png";
import pc_icon_3 from "@/assets/pc_icon_3.png";
import dy_icon from "@/assets/dy.png";
import wd_icon from "@/assets/wd.png";
import ewm from "@/assets/ewm.jpg";
import rightImg from '@/assets/right.png';
import config from "@/config";
import { getUrlKey } from "@/util/getKey.js";
const passportUrl = config[process.env.NODE_ENV].passportUrl;
const cjtUrl = config[process.env.NODE_ENV].cjtUrl;

export default {
  name: "HeaderNav",
  data() {
    return {
      pc_icon,
      pc_icon_4,
      pc_icon_2,
      pc_icon_3,
      ewm,
      dy_icon,
      wd_icon,
      rightImg,
      avtion: "/",
      cjt: false, //判断是否为畅捷通
      heardTitle: "税法随便问 一 中税答疑出品",
      titleList: "",
      sourceCode: "",
      //2021_10_29 畅捷通 隐藏退出按钮
      isHiddenLogout:'1',
    };
  },
  created() {
    this.getUserinfo();
    this.getDictionariesAll();
  },
  mounted() {
    this.avtion = this.$route.path;
    window.addEventListener("popstate", this.listenBack);
    this.sourceCode = this.$route.query.sourceCode;
    if(this.sourceCode === 'aisino') {
      document.body.style.backgroundColor = "#ffffff"
    }
    if (
      this.$route.query.orgId != undefined &&
      this.$route.query.orgId != "" &&
      this.$route.query.orgId != null
    ) {
      this.$store.commit("orgId", this.$route.query.orgId);
    }
    const num = this.$route.query.num;
    switch (num) {
      case "1":
        this.$router.push("/" + window.location.search);
        this.$nextTick( function(){
          this.avtion = "/";
        })
        break;
      case "2":
        this.$router.push("/question" + window.location.search);
        this.$nextTick( function(){
          this.avtion = "/question"
        })
        break;
      default:
        // this.$router.push("/" + window.location.search);
        break;
    }
  },
  methods: {
    getDictionariesAll() {
      let that = this;
      API_DATA.dictionariesAll().then((res) => {
        //遍历获取提示语
        res.data.map(function (item) {
          if (item.code == "chanjet_data") {
            //标题
            that.titleList = JSON.parse(item.value);
          }
        });
        this.changeTitle();
      });
    },
    changeTitle() {
      console.log(this.titleList)
      console.log(this.sourceCode)
      if (
        this.sourceCode !== undefined &&
        this.sourceCode !== null &&
        this.sourceCode !== ""
      ) {
        this.heardTitle = this.titleList[this.sourceCode].title;
        //判断当前页面是否需要隐藏退出按钮 liyanze分支2021_20_29新增隐藏退出按钮
        if(this.titleList[this.sourceCode].isHiddenLogout&&this.titleList[this.sourceCode].isHiddenLogout== 1){
          this.isHiddenLogout = 1
          //判断购买会员的链接
          if(this.titleList[this.sourceCode].payUrl&&this.titleList[this.sourceCode].payUrl!=''){
            //字符串替换
            let questBuyUrl = this.titleList[this.sourceCode].payUrl
            let strA = ''
            let strB = ''
            strA = questBuyUrl.replace('{{orgId}}',this.$route.query.orgId)
            strB = strA.replace('{{openid}}', this.$store.state.userInfo.openid)
            //将购买链接存入缓存
            sessionStorage.setItem("cjtIsHavePay", "yes");
            sessionStorage.setItem("cjtPayUrl", strB);
          }
        }else{
          sessionStorage.setItem("cjtIsHavePay", "no");
          this.isHiddenLogout = '999'
        }
      } else if (this.cjt) {
        this.heardTitle = this.titleList["chanjetDefault"].title;
        //判断当前页面是否需要隐藏退出按钮 liyanze分支2021_20_29新增隐藏退出按钮
        if(this.titleList[this.sourceCode].isHiddenLogout&&this.titleList[this.sourceCode].isHiddenLogout== 1){
          this.isHiddenLogout = 1
          //判断购买会员的链接
          if(this.titleList[this.sourceCode].payUrl&&this.titleList[this.sourceCode].payUrl!=''){
            //字符串替换
            let questBuyUrl = this.titleList[this.sourceCode].payUrl
            let strA = ''
            let strB = ''
            strA = questBuyUrl.replace('{{orgId}}',this.$route.query.orgId)
            strB = strA.replace('{{openid}}', this.$store.state.userInfo.openid)
            //将购买链接存入缓存
            sessionStorage.setItem("cjtIsHavePay", "yes");
            sessionStorage.setItem("cjtPayUrl", strB);
          }
        }else{
          sessionStorage.setItem("cjtIsHavePay", "no");
          this.isHiddenLogout = '999'
        }
      }else{
        this.isHiddenLogout = '999'
      }
      document.title = this.heardTitle;
    },
    routerLinkToPageHook(url) {
      if (url === "/question") {
        if (
          this.$store.state.userInfo.id == "" ||
          this.$store.state.userInfo.id == undefined ||
          this.$store.state.userInfo.id == null
        ) {
          this.$confirm("请登录后再查看", "提示", {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$store.commit("userDetail", "");
              window.location.href =
                passportUrl +
                "?client_id=sbw&redirectUrl=" +
                window.location.href;
            })
            .catch(() => {
              this.$router.push("/" + window.location.search);
              this.avtion = "/";
            });
        } else {
          this.isVip();
          console.log(url + window.location.search);
          this.$router.push(url + window.location.search);
        }
        this.$router.push(url + window.location.search);
      } else if (url === "/center") {
        //判断是不是畅捷通
        if (this.cjt === true) {
          window.open(this.$route.query.gotoLink, "_blank");
        } else {
          if (
            this.$store.state.userInfo.mobile == "" ||
            this.$store.state.userInfo.mobile == undefined ||
            this.$store.state.userInfo.mobile == null
          ) {
            this.$confirm("请登录后再查看", "提示", {
              confirmButtonText: "重新登录",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$store.commit("userDetail", "");
                window.location.href =
                  passportUrl +
                  "?client_id=sbw&redirectUrl=" +
                  window.location.href;
              })
              .catch(() => {
                this.$router.push(window.location.search);
                this.avtion = "/";
              });
          } else {
            this.$router.push(url + window.location.search);
          }
        }
      } else {
        this.$router.push(url + window.location.search);
        //this.$router.push(url);
      }
      this.avtion = url;
    },
    //获取用户信息
    getUserinfo() {
      API_DATA.userInfo().then((res) => {
        if (res.status === undefined) {
          this.$store.commit("userDetail", "");
        } else {
          this.$store.commit("userDetail", res.data.userInfo);
          localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
          this.isVip();
          if (res.data.userInfo.snsType) {
            var str = res.data.userInfo.snsType.indexOf("chanjet");
            if (str == 0) {
              this.cjt = true;
              this.$store.commit("CJT", true);
              console.log("畅捷通");
            }
          }
        }
      });
    },
    //获取vip信息
    isVip() {
      API_DATA.isVip()
        .then((res) => {
          this.$store.commit("isVip", res.data);
          localStorage.setItem('isVip', res.data)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //点击登录
    login() {
      var url = encodeURIComponent(location.href);
      window.location.href = passportUrl + "?client_id=sbw&redirectUrl=" + url;
    },
    //点击退出
    logout() {
      this.$confirm("是否确认登出税法随便问?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var redirectUrl =
            window.location.protocol + "//" + window.location.host;
          var url = encodeURIComponent(redirectUrl);
          this.$store.commit("userDetail", "");
          this.$store.commit("CJT", false);
          window.location.href = passportUrl + "api/logout?redirect_uri=" + url;
        })
        .catch(() => {});
    },
    // 跳转外部来链接
    tolink(url) {
      // window.open(url, "_blank");
      // window.location.href = url;
      if ( window.location.search === ''){
        console.log(window.location.search)
        this.$router.push( '/webview' + '?url=' + url )
      } else {
        this.$router.push( '/webview' + window.location.search + '&url=' + url )
      }
    },
    listenBack() {
      this.avtion = this.$route.path;
    },
  },
};
</script>
<style lang="scss" scoped>
.heard {
  display: grid;
  grid-template-rows: auto 1fr;
}
.nav-box {
  background-color: #ffffff;
  height: 70px;
  line-height: 70px;
}
.nav {
  width: 1200px;
  margin: 0 auto;
}
.nav > span {
  font-family: MicrosoftYaHei-Bold;
  font-size: 22px;
  letter-spacing: 0px;
  color: #222222;
  font-weight: 600;
}
.nav-btn {
  float: right;
}
.nav-btn /deep/ .el-button--primary.is-plain {
  border-color: #2270e6;
  color: #2270e6;
  background-color: #fff;
}
.nav-btn /deep/ .el-button {
  width: 50px;
  height: 34px;
  line-height: 34px;
  padding: 0px;
}
.tab-box {
  display: grid;
  grid-template-columns: auto auto;
  width: 1200px;
  margin: 10px auto 0;
  overflow: hidden;
}
.nav-tab {
  width: 930px;
  height: 30px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-radius: 10px;
  float: left;
  padding: 20px 30px;
}
.cjtTs {
  width: 400px;
  float: right;
  height: 30px;
  line-height: 30px;
  background-color: #f8ebd7;
  font-size: 14px;
  color: #222222;
  text-align: center;
}
.tool-right {
  display: grid;
  grid-template-rows: auto 1fr;
}
.nav-right {
  width: 160px;
  padding: 0px 20px;
  min-height: 280px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-radius: 10px;
  float: left;
  font-size: 1rem;
  margin-left: 10px;
  margin-bottom: 20px;
}
.tab-name {
  width: 100px;
  height: 30px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #222222;
  margin-right: 70px;
  line-height: 30px;
  cursor: pointer;
  float: left;
  text-align: center;
}
.atab-name {
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: #e0edfb;
  color: #2270e6;
  border-radius: 10px;
  float: left;
  text-align: center;
  margin-right: 70px;
  cursor: pointer;
}
.nav-content {
  width: 990px;
  display: grid;
  grid-template-rows: auto 1fr;
  float: left;
}
.web-view {
  width: 70px;
  margin: 0 auto;
  float: left;
  cursor: pointer;
}
.web-icon {
  width: 50px;
  height: 50px;
  margin: 40px auto 0px;
}
.web-icon > img {
  width: 100%;
  height: 100%;
}
.web-view > p {
  margin-top: 14px;
  margin-bottom: 0px;
  font-size: 16px;
  text-align: center;
}
.web-view:nth-child(odd) {
  margin-right: 20px;
}
.nav-name {
  color: #2270e6;
  margin-right: 10px;
}
.nav-logout {
  cursor: pointer;
}
.remind-title {
  color: #e25d5b;
  font-weight: bold;
}
.remind-content {
  color: #222222;
  text-indent: 2rem;
  line-height: 1.5rem;
}
.remind-img {
  width: 100%;
}

// 定制版CSS
.edition{
  color: #4b8bff;
  font-size: 16px;
  position: absolute;
  // float: right;
  right: 5%;
  line-height: 40px;
}
.empty-div{
  position: absolute;
  top: 54px;
  width: 90%;
  border-bottom: 1px solid #b7b7b7;
  float: left;
}
.aisino-heard {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-rows: auto 1fr;
  background-color: #ffffff;
}
.aisino-tab-box {
  width: 100%;
  margin: 10px auto 0;
  // overflow: hidden;
}
.aisino-nav-content {
  width: 85%;
  float: left;
}
.aisino-nav-tab {
  width: 96%;
  height: 40px;
  background-color: #ffffff;
  // box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-bottom: 1px solid #b7b7b7;
  // border-radius: 10px;
  float: left;
  padding: 0 20px 4px 20px;
  // padding-bottom: 3px;
}
.aisino-tool-right {
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr;
  float: right;
  top: 45px;
  width: 15%;
}
.aisino-nav-right {
  width: 160px;
  padding: 0px 15px;
  // min-height: calc(100vh - 91px);
  // max-height: calc(100vh - 91px);
  background-color: #ffffff;
  // box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  // border-radius: 10px;
  float: left;
  font-size: 1rem;
  // margin-left: 10px;
  margin-bottom: 20px;
}
.aisino-nav-right-img {
  // text-align: center;
  // margin: 10px 0;
  width: 100%;
}
.aisino-nav-right-img img{
  width: 100%;
  // height: 500px;
  height: calc(100vh - 60px);
}

.aisino-nav-btn {
  float: right;
  height: 40px;
  line-height: 40px;
}
.aisino-nav-btn >>> .el-button--primary.is-plain {
  border-color: #2270e6;
  color: #2270e6;
  background-color: #fff;
}
.aisino-nav-btn >>> .el-button {
  width: 50px;
  height: 34px;
  line-height: 34px;
  padding: 0px;
}
.nav-icon {
  filter: drop-shadow(40px 6px #9e9fa1);
  right: 40px;
  float: left;
  position: relative;
  -webkit-filter: drop-shadow(40px 6px #9e9fa1);
}
.aisino-atab-name {
  overflow: hidden;
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  // background-color: #e0edfb;
  // color: #2270e6;
  color: #1e1e1e;
  // border-radius: 10px;
  float: left;
  border-bottom: 4px solid #448aca;
  text-align: center;
  margin-right: 70px;
  cursor: pointer;
}
.aisino-tab-name {
  overflow: hidden;
  width: 100px;
  height: 40px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  font-size: 18px;
  color: #878787;
  margin-right: 70px;
  line-height: 40px;
  cursor: pointer;
  float: left;
  text-align: center;
}
.aisino-remind-title {
  text-align: center;
  font-size: 16px;
  color: #414141;
  font-family: '微软雅黑';
}
.aisino-remind-img {
  width: 100%;
}
.aisino-remind-content {
  text-align: center;
  font-size: 14px;
  color: #4b8bff;
}
</style>